import React from 'react';
import { S3File } from './S3File';
import { S3Field } from './S3Field';

export const S3FileField = (props) => {
  return (
    <S3Field {...props}>
      <S3File />
    </S3Field>
  );
};
